/** Parent rendezvous machine `state.value` when TV activation completed successfully. */
export const RENDEZVOUS_ACTIVATION_SUCCESS_STATE = 'exit' as const;
export const RENDEZVOUS_LOCAL_STORAGE_KEY = 'rendezvousContext';
export const LEGACY_RENDEZVOUS_SIGN_IN_URL = '/account/flow/tn-rendezvous/action/login/';

export type ActivationScreen = 'SIGN_IN' | 'SIGN_UP';
export const DEFAULT_ACTIVATION_SCREEN = 'SIGN_IN';

export type DeviceInfo = {
    activationCode: string;
    activationScreen: ActivationScreen;
    device?: {
        name: string;
        partner: string;
    };
};

export type RendezvousFlowContext = Partial<DeviceInfo> & {
    defaultRegionCode: string;
};

export type TvOutput = Required<DeviceInfo>;

export type TvCompleteOutput = Partial<DeviceInfo> & {
    activationDidFail: boolean;
};
